/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentSessionMeta,
  AgentSessionMeta$inboundSchema,
} from "./agentsessionmeta.js";

export type GetSessionMetaResult = {
  /**
   * Metadata for the requested sessions that exist and are owned by the calling user. Requested ids with no captured chat or another owner are omitted.
   */
  sessions: Array<AgentSessionMeta>;
};

/** @internal */
export const GetSessionMetaResult$inboundSchema: z.ZodMiniType<
  GetSessionMetaResult,
  unknown
> = z.object({
  sessions: z.array(AgentSessionMeta$inboundSchema),
});

export function getSessionMetaResultFromJSON(
  jsonString: string,
): SafeParseResult<GetSessionMetaResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetSessionMetaResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetSessionMetaResult' from JSON`,
  );
}
